import { render, staticRenderFns } from "./CostsList.vue?vue&type=template&id=849b87ee&scoped=true&"
import script from "./CostsList.vue?vue&type=script&lang=js&"
export * from "./CostsList.vue?vue&type=script&lang=js&"
import style0 from "./CostsList.vue?vue&type=style&index=0&id=849b87ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849b87ee",
  null
  
)

export default component.exports